export const SortingFunction = (a: any, b: any) =>
  new Date(a.created_at).getTime() - new Date(b.created_at).getTime();
